import '../App.css';
import Download from '../components/download';
import User from '../components/user';
import Assets from '../components/assets';
import React, { useState, useEffect } from 'react';

import { ToastProvider } from '../components/useToast';

const App = () => {
  const [business, setBusiness] = useState(null);
  const [params, setParams] = useState({});
  const [agent, setAgent] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const getParams = () => {
    //获取地址url中的全部参数
    let url = window.location.href;
    let params = {};
    let query = url.split('?')[1];
    if (query) {
      let pairs = query.split('&');
      for (let i = 0; i < pairs.length; i++) {
        let pair = pairs[i].split('=');
        params[pair[0]] = pair[1];
      }
    }
    return params;
  }

  useEffect(() => {
    const queryParams = getParams();
    setParams(queryParams);
    if (queryParams.business !== undefined) {
      setBusiness(queryParams.business);
      setLoaded(true);
    }
    if (queryParams.business === undefined) {
      //是短链接
      const myHeaders = new Headers();
      fetch(`${process.env.REACT_APP_BASE_URL}/free-api/v1/share/original-url?url=${window.location.href}`, {
        method: 'GET',
        headers: myHeaders,
        mode: 'cors',
        cache: 'default'
      })
        .then(response => response.json())
        .then(res => {
          if (res.code == 0 && res.data != "") {
            window.location.href = res.data;
          } else {
            //可以展示页面了
            setLoaded(true);
          }
        })
        .catch(error => {
          // 处理错误
          console.error(error);
        });
    }
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    var isWeixin = u.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
    var isMiniProgram = isWeixin && u.toLowerCase().indexOf('mini') > -1; // 判断是否为微信小程序
    if (isMiniProgram) {
      setAgent('miniProgram'); // 设置代理为小程序
    } else if (isWeixin) {
      setAgent('weixin');
    } else if (isAndroid) {
      setAgent('android');
    } else if (isiOS) {
      setAgent('ios');
    }
  }, [])
  return (
    <>
      {
        loaded && <div className='App'>
          {business == 0 && <ToastProvider><User data={params} agent={agent} /></ToastProvider>}
          {business == 3 && <Assets data={params}></Assets>}
          {business != 0 && business != 3 && <Download data={params} agent={agent} />}
        </div>
      }
    </>
  );
}

export default App;
